import './App.css';
import Accueil from './pages/accueil';
import Collection from './pages/collection';
import PaintingDetail from './pages/PaintingDetail';
import Layout from './components/Layout';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Accueil />
      },
      {
        path: 'collection',
        element: <Collection />
      },
      {
        path: 'painting/:id',
        element: <PaintingDetail />
      }
    ]
  }
])

function App() {
  return <RouterProvider router={router} />
}

export default App;
